module.exports = __webpack_public_path__ + "static/media/cvmns2.725afabf.jpg";